import { useState } from 'react';
import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess(false);

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormSuccess(true);
      form.reset();
      setTimeout(() => setFormSuccess(false), 3000);
      return;
    }
    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9mrd1obdkpk99j7gde0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed && (parsed as Record<string, string>).code === 'OK') {
        setFormSuccess(true);
        form.reset();
        setTimeout(() => setFormSuccess(false), 3000);
      } else {
        const msg = (parsed && typeof (parsed as Record<string, unknown>).meta === 'object' && ((parsed as Record<string, unknown>).meta as Record<string, string>).message)
          || (parsed && (parsed as Record<string, string>).message)
          || responseText;
        setFormError(String(msg));
      }
    } catch {
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {contactData.description}
            </p>

            <div className="mt-6 md:mt-8 space-y-4">
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">电子邮箱</p>
                  <p className="font-medium">{contactData.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/80 text-secondary-600">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">微信公众号</p>
                  <p className="font-medium">{contactData.wechat}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600">
                  <i className="ri-qq-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">QQ群</p>
                  <p className="font-medium">{contactData.qq}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-500">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200">
                  <i className="ri-time-line text-lg"></i>
                </span>
                <p>{contactData.hours}</p>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-7">
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-5">发送消息</h3>
              <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="您的称呼"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors"
                    required
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="电子邮箱"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors"
                    required
                  />
                </div>
                <div>
                  <textarea
                    name="message"
                    placeholder="请输入您的建议或反馈..."
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                    required
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {formSuccess ? '✓ 已发送' : '发送消息'}
                </button>
                {formError && (
                  <p className="text-xs text-accent-500 text-center">{formError}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}